(() => {
  const dialog = document.getElementById('offer-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const firstDelay = 10_000;
  const repeatDelay = 60_000;
  const endsAt = Number(dialog.dataset.endsAt) * 1000;
  const theme = window.Shopify?.theme;
  const previewSuffix = theme && theme.role !== 'main' ? `:preview:${theme.id}` : '';
  const storageKey = `heliconia:september-2026-offer${previewSuffix}`;
  let timer;
  let storageAvailable = true;
  let state;

  // A page session survives navigation and reloads in the same shopping tab.
  // Keep the two-display limit even when session storage is unavailable by
  // withholding the automatic popup in browsers where it cannot be recorded.
  try {
    state = JSON.parse(window.sessionStorage.getItem(storageKey));
  } catch (_) {
    storageAvailable = false;
  }
  if (!storageAvailable) return;
  if (!state || !Number.isInteger(state.views) || state.views < 0 || state.views > 2
    || (state.nextAt !== null && !Number.isFinite(state.nextAt))) {
    state = { views: 0, nextAt: Date.now() + firstDelay };
  } else if (state.views === 1 && state.nextAt === null) {
    // The visitor left the previous page while the first popup was open.
    state.nextAt = Date.now() + repeatDelay;
  }

  const save = () => {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(state));
    } catch (_) {
      storageAvailable = false;
    }
  };
  save();

  const dismiss = () => {
    document.documentElement.classList.remove('offer-popup-open');
    if (state.views === 1 && state.nextAt === null) {
      state.nextAt = Date.now() + repeatDelay;
      save();
    }
    schedule();
  };

  const close = () => {
    if (!dialog.open) return;
    dialog.close();
    dismiss();
  };

  const busy = () => document.body.classList.contains('js-drawer-open')
    || document.querySelector('dialog[open]:not(#offer-popup), [aria-modal="true"]:not([aria-hidden="true"]), .fancybox-opened, #popup.visible')
    || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName);

  function schedule() {
    window.clearTimeout(timer);
    const now = Date.now();
    if (!storageAvailable || !Number.isFinite(endsAt) || now >= endsAt) {
      if (dialog.open) dialog.close();
      document.documentElement.classList.remove('offer-popup-open');
      return;
    }
    if (dialog.open) {
      timer = window.setTimeout(schedule, Math.min(endsAt - now, 2_147_483_647));
      return;
    }
    if (state.views >= 2) return;
    if (document.hidden) return;

    if (now >= state.nextAt) {
      if (busy()) {
        timer = window.setTimeout(schedule, Math.min(1000, endsAt - now));
        return;
      }
      state.views += 1;
      state.nextAt = null;
      save();
      if (!storageAvailable) return;
      dialog.showModal();
      document.documentElement.classList.add('offer-popup-open');
      timer = window.setTimeout(schedule, Math.min(endsAt - now, 2_147_483_647));
      return;
    }
    timer = window.setTimeout(schedule, Math.min(state.nextAt - now, endsAt - now, 2_147_483_647));
  }

  dialog.querySelector('.offer-popup__close').addEventListener('click', close);
  dialog.querySelector('.offer-popup__dismiss').addEventListener('click', close);
  dialog.querySelector('.offer-popup__shop').addEventListener('click', close);
  dialog.addEventListener('close', dismiss);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right
      || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  document.addEventListener('visibilitychange', schedule);
  window.addEventListener('pagehide', () => { close(); window.clearTimeout(timer); });
  window.addEventListener('pageshow', () => {
    // A Back navigation can restore an older page with an older in-memory count.
    try {
      const saved = JSON.parse(window.sessionStorage.getItem(storageKey));
      if (saved) state = saved;
    } catch (_) {
      storageAvailable = false;
    }
    schedule();
  });
  schedule();
})();
